import Dropzone from 'react-dropzone'
import { FileSearchOutlined } from '@ant-design/icons'

import { ICardListener } from './types'

import { Flex, Loader, Drawer, Divider, Button, Tab } from '@ui/index'
import { IconClearClose, IconFiles, IconListeners, IconLogs, IconMainGrid } from '@img/icons'


/** Карточка по слушателю */
export const CardListener = ({
    isOpen, cardMode, filesList,
    isLoading, isRecognitionLoading, isFilePreparing, filePreparationProgress, handlerShowFilePreparation, isDisableBtnSave, tabActive, listenerNumber, listenerDateCreate,
    fileUploader,
    getCardPage, handleBtnSave, 
    handlerDownloadFiles, handlerDeleteFiles, handlerRecognizeFiles, handleBtnClose
}: ICardListener) => {


    const getCardPageBtnPanel = (tabActive: string) => {
        switch (tabActive) {
            case 'primary': {
                return <Flex gap='4px'>
                    <Divider />
                    <Flex flexDirection='row' gap='4px' justifyContent='flex-end'>
                        <Button flexGrow={1} padding='0 10px' isDisabled={isDisableBtnSave.value || isLoading} onClick={() => handleBtnSave(true)}>Сохранить и закрыть</Button>
                        <Button flexGrow={1} padding='0 10px' isDisabled={isDisableBtnSave.value || isLoading} onClick={() => handleBtnSave(false)}>Сохранить</Button>
                    </Flex>
                </Flex>
            }

            case 'files': {
                return <Flex gap='4px'>
                    <Divider />
                    <Flex flexDirection='row' gap='4px' justifyContent='flex-end' flexWrap='wrap'>
                        <Flex flexDirection='row' gap='4px' isRendered={filesList.value.filter((item) => item.isSelected).length > 0}>
                            <Button padding='0 10px' variant='primaryDark' isDisabled={isFilePreparing} onClick={() => handlerDeleteFiles()}>Удалить</Button>
                            <Button padding='0 10px' variant='primaryDark' onClick={() => handlerDownloadFiles()}>Скачать</Button>
                            <Divider type='vertical' margin='8px' />
                        </Flex>

                        <Button padding='0 10px' variant='primaryDark' isLoading={isRecognitionLoading} isDisabled={isLoading || isRecognitionLoading || isFilePreparing || !filesList.value.some(item => item.isSelected)} onClick={handlerRecognizeFiles}>
                            <FileSearchOutlined aria-hidden='true' /> Распознать
                        </Button>

                        <Dropzone disabled={isFilePreparing} onDropAccepted={(files) => fileUploader(files)}>
                            {({ getRootProps, getInputProps }) => (
                                <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <Button padding={'0 10px'} isDisabled={isFilePreparing}>Загрузить</Button>
                                </div>
                            )}
                        </Dropzone>
                    </Flex>
                </Flex>
            }
            case 'logs': return ''
        }
    }

    return <>
        <Drawer isOpen={isOpen} placement='bottom' size='99.4%'>
            <Flex className='drawer_container'>
                <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                    <header>
                        <Flex gap='4px' flexDirection='row' alignItems='center'>
                            <IconListeners color='#fff' width='20px' height='20px' />
                            <h4>{cardMode === 'edit' ? 'Анкета слушателя' : 'Создание слушателя'}</h4>
                        </Flex>

                        {cardMode === 'edit' && <h5>№ {listenerNumber.value} от {listenerDateCreate.value}</h5>}
                    </header>

                    <Button variant='icon' size='md' isDisabled={isLoading} onClick={handleBtnClose}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Flex gap='4px' className='drawer_container-body_bottom_panel'>
                    <Flex gap='6px' className='drawer_container-content' overflowY={tabActive.value === 'files' ? 'hidden' : 'scroll'} padding={tabActive.value === 'files' ? '2px 0px 0px 0px' : '4px 8px 4px 4px'}>
                        {getCardPage(tabActive.value)}
                    </Flex>

                    {filePreparationProgress && <Flex flexDirection='row' alignItems='center' justifyContent='space-between' gap='8px' padding='4px 8px'>
                        <span role='status' aria-live='polite'>{filePreparationProgress.phase === 'saving'
                            ? 'Добавление файлов в анкету…'
                            : `Обработано файлов: ${filePreparationProgress.completed} из ${filePreparationProgress.total}`}</span>
                        <Button size='sm' padding='0 10px' onClick={handlerShowFilePreparation}>Ход обработки</Button>
                    </Flex>}
                    {getCardPageBtnPanel(tabActive.value)}
                </Flex>

                <Tab.Container>
                    <Tab.Item tabName='primary' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Основные данные' onClick={tabActive.setValue}><IconMainGrid /></Tab.Item>
                    <Tab.Item tabName='files' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Файлы слушателя' onClick={tabActive.setValue}><IconFiles /></Tab.Item>
                    <Tab.Item tabName='logs' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Журнал изменений' onClick={tabActive.setValue}><IconLogs /></Tab.Item>
                </Tab.Container>

                <Loader isOpen={isLoading} title='Загрузка анкеты...' backdrop />
            </Flex>
        </Drawer>
    </>
}
